/**
 * NexoNurse Icon Size Scale
 *
 * Two exports:
 *   ICON    — Tailwind className strings  → use with SVG/className-based icons
 *   ICON_PX — numeric pixel values        → use with lucide-react `size` prop
 *
 * Usage:
 *   import { ICON, ICON_PX } from '../ui/lib/iconSizes';
 *   <Settings className={ICON.md} />          // Tailwind
 *   <Settings size={ICON_PX.md} />            // lucide size prop
 *
 * Scale (aligned so md = default action icon, matching Inbox tab reference):
 *   xs  — 10px  — inline text indicators, badge-internal icons
 *   sm  — 12px  — compact sidebars, dense table row actions
 *   md  — 14px  — default action icons, card controls, modal header icons  ← use this most of the time
 *   lg  — 20px  — nav menu icons, section headers
 *   xl  — 24px  — page-level icons, empty-state icons
 *   2xl — 32px  — illustration-scale icons in onboarding or empty states
 */
export const ICON = {
  xs:    'h-2.5 w-2.5',
  sm:    'h-3 w-3',
  md:    'h-3.5 w-3.5',
  lg:    'h-5 w-5',
  xl:    'h-6 w-6',
  '2xl': 'h-8 w-8',
};

export const ICON_PX = {
  xs:    10,
  sm:    12,
  md:    14,
  lg:    20,
  xl:    24,
  '2xl': 32,
};

/**
 * Stroke width is always 2 (lucide default).
 * Do NOT use strokeWidth prop unless you have a specific design reason.
 */
export const ICON_STROKE = 2;
